import React, { useState } from 'react';
import { HStack, Heading, Spinner, VStack } from 'native-base';
import { BlurView } from 'expo-blur';

// Assets
import { theme } from '@breakroom-nx/assets';
import { PrimaryButton, TertiaryButton } from '../../';
import { PermissionStatus } from '@breakroom-nx/helpers';

interface MapRegionLoadingProps {
  isDisabled: boolean;
  locationServiceStatus: PermissionStatus;
  geolocationControlRef: React.MutableRefObject<null>;
  checkGeolocation: any;
  isLoading: boolean;
  onGetRooms: () => void;
}

export function MapRegionLoading({
  isDisabled,
  locationServiceStatus,
  geolocationControlRef,
  checkGeolocation,
  onGetRooms,
  isLoading,
}: MapRegionLoadingProps) {
  const locationServicesStatusData = () => {
    switch (locationServiceStatus) {
      case PermissionStatus.Enabled:
        return { text: 'Locate Me', color: 'white' };
      case PermissionStatus.Unavailable:
        return {
          text: 'Location Services Unavailable',
          color: theme.colors.surface[600],
        };
      case PermissionStatus.NotSet:
        return {
          text: 'Please enable location services',
          color: theme.colors.surface[600],
        };
    }
  };

  return (
    <VStack alignItems={'center'} space={3}>
      {isLoading ? (
        <BlurView intensity={50} tint={'dark'} style={{ borderRadius: 50 }}>
          <HStack space={2} px={5} py={2}>
            <Heading color="primary.500" fontSize="md">
              Getting rooms in region
            </Heading>
            <Spinner color={theme.colors.primary[400]} />
          </HStack>
        </BlurView>
      ) : (
        <PrimaryButton
          text={'Find Rooms Here'}
          disabled={isLoading || isDisabled}
          onPress={() => {
            onGetRooms();
          }}
        />
      )}
      <TertiaryButton
        text={locationServicesStatusData().text}
        fontWeight={700}
        color={locationServicesStatusData().color}
        px={locationServiceStatus === PermissionStatus.Enabled ? '14px' : 5}
        onPress={() => {
          if (locationServiceStatus !== PermissionStatus.Enabled) {
            // Display notification about how to enable location services
          } else {
            geolocationControlRef
              ? geolocationControlRef.current.trigger()
              : null;
          }
        }}
        style={{
          width: '100%',
          opacity: locationServiceStatus !== PermissionStatus.Enabled ? 0.5 : 1,
        }}
      />
    </VStack>
  );
}

export default React.memo(MapRegionLoading);
